/**
 * @licence MIT
 * @author Sergey Melyukov
 */

module.exports = require('./main');



//////////////////
// WEBPACK FOOTER
// ./node_modules/image-preloader/src/index.js
// module id = 445
// module chunks = 0